import { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import {
    createDutyGroupApi,
    readAllDutyGroupsApi,
    readDutyGroupByIdApi,
    readGroupTypeSelectBoxApi,
    readOrgSelectBoxApi,
    readRoleSelectBoxApi,
    updateDutyGroupApi
} from "../../../../api/manage/role/DutyGroupApi";
import { useParams } from "react-router-dom";
import { RolesAuthInterface, RolesInfoInterface } from "./interface/RolesInterface";
import { RoleAccess } from "./tab/access";
import { RoleUsers } from "./tab/roleUsers";
import { RolesAuthInit, RolesInfoInit } from "./init/RolesInit";
import { useModal } from "../../../../hooks";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import { useUser } from "../../../../util/userContext/UserContext";
import AuthorityChecker from "../../../../components/common/authorityGuard/AuthorityChecker";

export const RoleCreate = () => {
    const { user } = useUser()
    const { goToNavigation } = useGoToNavigation();
    const [tab, setTab] = useState("1");
    const [roleInfoData, setRoleInfoData] = useState<RolesInfoInterface>(RolesInfoInit)
    const [roleAuthData, setRoleAuthData] = useState<RolesAuthInterface>(RolesAuthInit)
    const [roleList, setRoleList] = useState<RolesInfoInterface[]>()
    const { id } = useParams();
    const [groupTypeSelectBoxList, setGroupTypeSelectBoxList] = useState([]);
    const [orgSelectBoxList, setOrgTypeSelectBoxList] = useState([]);
    const [roleSelectBoxList, setRoleSelectBoxList] = useState([]);
    const { handleModal } = useModal();

    useEffect(() => {
        const fetchData = async () => {
            try {
                await Promise.all([
                    // readGroupTypeSelectBoxApiMutate.mutateAsync(),
                    readOrgSelectBoxApiMutate.mutateAsync(),
                    readRoleSelectBoxApiMutate.mutateAsync()
                ]);
                if (id) {
                    await readDutyGroupByIdApiMutate.mutateAsync();
                }
            } catch (err) {
                console.error(err);
            }
        };

        fetchData();
    }, [id]);

    const readDutyGroupByIdApiMutate = useMutation({
        mutationFn: () => readDutyGroupByIdApi({ dutyGroupId: id }),
        onSuccess: res => {
            if (res.data.code === "0000") {
                setRoleInfoData(prev => ({ ...prev, ...res.data.result.dutyGroupVO }))
                setRoleAuthData(prev => ({ ...prev, ...res.data.result.authorityVO }))
            }
        },
        onError: res => {
            alert(res)
        }
    });

    const readAllDutyGroupsApiMutate = useMutation({
        mutationFn: () => readAllDutyGroupsApi({}),
        onSuccess: res => {
            if (res.data.code === "0000") {
                setRoleList(res.data.result.userList)
                const selectedRole = res.data.result.userList[0]
                if (!id) {
                    setRoleInfoData(prev => ({
                        ...prev,
                        dutyGroupId: selectedRole.dutyGroupId,
                        // dutyGroupTypeName: selectedRole.dutyGroupTypeName,
                        // orgName: selectedRole.orgName,
                        // roleName: selectedRole.roleName,
                        // dutyGroupRemark: selectedRole.dutyGroupRemark,
                        dutyGroupName: selectedRole.dutyGroupName,
                    }));
                }
            } else {
            }
        },
        onError: res => {
            alert(res)
        }
    });

    const readOrgSelectBoxApiMutate = useMutation({
        mutationFn: () => readOrgSelectBoxApi(),
        onSuccess: res => {
            if (res.data.code === "0000") {
                setOrgTypeSelectBoxList(res.data.result)
                // if (!id && res.data.result.length > 0) {
                //     setRoleInfoData(prev => ({ ...prev, codeOrgId: res.data.result[0].id }))
                // }
            }
        },
        onError: res => alert(res)
    })

    const readRoleSelectBoxApiMutate = useMutation({
        mutationFn: () => readRoleSelectBoxApi(),
        onSuccess: res => {
            if (res.data.code === "0000") {
                setRoleSelectBoxList(res.data.result)
                // if (!id && res.data.result.length > 0) {
                //     setRoleInfoData(prev => ({ ...prev, codeRoleId: res.data.result[0].id }))
                // }
            }
        },
        onError: res => alert(res)
    })

    // const readGroupTypeSelectBoxApiMutate = useMutation({
    //     mutationFn: () => readGroupTypeSelectBoxApi(),
    //     onSuccess: res => {
    //         if (res.data.code === "0000") {
    //             setGroupTypeSelectBoxList(res.data.result)
    //             if (!id && res.data.result.length > 0) {
    //                 setRoleInfoData(prev => ({ ...prev, codeDutyGroupTypeId: res.data.result[0].id }))
    //             }
    //         }
    //     },
    //     onError: res => alert(res)
    // })

    const makeCreateDutyData = () => {
        if (roleInfoData.dutyGroupName === "") {
            handleModal({ isOpen: true, contents: "역할ID를 입력해주세요.", type: "alert" })
            return;
        }

        const data = { authorityVO: roleAuthData, dutyGroupVO: roleInfoData };

        if (roleInfoData.codeDutyGroupTypeId === 0 || roleInfoData.codeOrgId === 0 || roleInfoData.codeRoleId === 0) {
            handleModal({
                isOpen: true,
                title: '필수 입력',
                contents: '구분, 조직, 역할은 필수 입력 항목입니다.',
                type: 'alert'
            })
            return;
        }
        if (id) updateDutyGroupApiMutate.mutate(data)
        else createDutyGroupApiMutate.mutate(data)

    }

    const createDutyGroupApiMutate = useMutation({
        mutationFn: (role: any) => createDutyGroupApi(role),
        onSuccess: res => {
            if (res.data.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: "역할 그룹이 생성 되었습니다.",
                    type: "alert",
                    closeAction: () => goToNavigation(`manage/role/list`, "", false)
                })
            } else {
                handleModal({ isOpen: true, contents: "역할 그룹 생성을 실패했습니다.", type: "alert" })
            }
        },
        onError: res => {
            alert(res)
        }
    });

    const updateDutyGroupApiMutate = useMutation({
        mutationFn: (role: any) =>
            updateDutyGroupApi({
                ...role,
                dutyGroupVO: {
                    ...role.dutyGroupVO, // 기존 객체 유지
                    groupId: Number(id) // groupId만 업데이트
                }
            }),
        onSuccess: res => {
            if (res.data.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: "역할 그룹정보를 수정하였습니다.",
                    type: "alert",
                    closeAction: () => goToNavigation(`manage/role/list`, "", false)
                })
            } else {
                handleModal({ isOpen: true, contents: "역할 그룹정보 수정을 실패했습니다.", type: "alert" })
            }
        },
        onError: res => {
            alert(res)
        }
    });

    useEffect(() => {
        if (id) {
            readDutyGroupByIdApiMutate.mutate()
            readAllDutyGroupsApiMutate.mutate()
        }

        // readGroupTypeSelectBoxApiMutate.mutate()
        readOrgSelectBoxApiMutate.mutate()
        readRoleSelectBoxApiMutate.mutate()
    }, [])

    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">역할 {id ? "상세보기" : "생성하기"}</h3>
                    <div className="filter_toolbar">
                        <AuthorityChecker authorityNames={['roleWriteYn']}>
                            <button className="btn btn-primary w-100px h-38px"
                                onClick={() => makeCreateDutyData()}>{id ? "저장" : "생성"}</button>
                            <button className="btn btn-outline-secondary w-100px h-38px"
                                onClick={() => goToNavigation(`manage/role/list`, "", false)}>취소
                            </button>
                        </AuthorityChecker>
                    </div>
                </div>
                <h5 className="subheading">역할 정보</h5>

                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>역할 ID</th>
                            <td style={{ width: "31.3%" }}>
                                {id ? roleInfoData?.dutyGroupName : <input
                                    type="text"
                                    className="form-control"
                                    name="items-name"
                                    value={roleInfoData?.dutyGroupName}
                                    onChange={(e) => setRoleInfoData({ ...roleInfoData, dutyGroupName: e.target.value })}
                                />}
                            </td>
                            <th style={{ width: "16.66%" }}>구분</th>
                            <td className="p-4px"><select
                                className="form-select"
                                name="role-roleName"
                                // value={id ? roleInfoData.codeDutyGroupTypeId : (groupTypeSelectBoxList as any)[0]?.id}
                                value={roleInfoData.codeDutyGroupTypeId ?? ''}
                                onChange={(e) =>
                                    setRoleInfoData({ ...roleInfoData, codeDutyGroupTypeId: Number(e.target.value) })
                                }
                                disabled={user?.authority.roleWriteYn === "N"}
                            >
                                <option value={0}>선택</option>
                                <option value={23}>{'내부'}</option>
                                <option value={24}>{'외부'}</option>
                            </select></td>
                        </tr>
                        <tr>
                            <th>조직</th>
                            <td className="p-4px"><select
                                className="form-select"
                                name="role-roleName"
                                // value={id ? roleInfoData.codeOrgId : (orgSelectBoxList as any)[0]?.id}
                                value={roleInfoData.codeOrgId ?? ''}
                                onChange={(e) => {
                                    setRoleInfoData({ ...roleInfoData, codeOrgId: Number(e.target.value) })
                                }}
                                disabled={user?.authority.roleWriteYn === "N"}
                            >
                                <option value={0}>선택</option>
                                {orgSelectBoxList.length > 0 && orgSelectBoxList.map((el: any) =>
                                    <option value={el.id}>{el.name}</option>
                                )}
                            </select></td>
                            <th>역할</th>
                            <td className="p-4px"><select
                                className="form-select"
                                name="role-roleName"
                                // value={id ? roleInfoData.codeRoleId : (roleSelectBoxList as any)[0]?.id}
                                value={roleInfoData.codeRoleId ?? ''}
                                onChange={(e) => {
                                    setRoleInfoData({ ...roleInfoData, codeRoleId: Number(e.target.value) })
                                }}
                                disabled={user?.authority.roleWriteYn === "N"}
                            >
                                <option value={0}>선택</option>
                                {roleSelectBoxList.length > 0 && roleSelectBoxList.map((el: any) =>
                                    <option value={el.id}>{el.name}</option>
                                )}
                            </select></td>
                        </tr>
                        <tr>
                            <th>설명</th>
                            <td className="p-4px" colSpan={4}>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="role-dutyGroupRemark"
                                    value={roleInfoData?.dutyGroupRemark}
                                    onChange={(e) => setRoleInfoData({ ...roleInfoData, dutyGroupRemark: e.target.value })}
                                    disabled={user?.authority.roleWriteYn === "N"}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="mybtns_group">
                <div className="btn-group" role="group" aria-label="">
                    {/* <button type="button" className={tab == "tab-1" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-1")}>역할정보</button> */}
                    <button type="button" className={tab == "1" ? "btn btn-light active" : "btn btn-light"}
                        onClick={() => setTab("1")}>접근권한
                    </button>
                    {id && <button type="button" className={tab == "2" ? "btn btn-light active" : "btn btn-light"}
                        onClick={() => setTab("2")}>구성원</button>}
                </div>
                <div className="mybtns_group_toolbar"></div>
            </div>
            {tab && tab === "1" ? (
                <RoleAccess
                    roleAuthData={roleAuthData}
                    setRoleAuthData={setRoleAuthData}
                />
            ) : tab === "2" ?
                <RoleUsers /> : ""
            }
        </>
    );
}